/* PT · Homepage behaviour (spec-homepage-4a4b): press quote cycler (4s, 600ms
   cross-fade, click pins, pauses off-screen / under reduced motion), scroll-in
   reveals (once, staggered 60ms), one-time stat count-up, transparent→paper
   header over the splash (cross-fade ~250ms), pressed-state hold on links.
   Theme Editor: re-inits on section load. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.documentElement.classList.remove("pt-nojs");

  /* ---- links that leave the page hold the pressed state (site language) ---- */
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest(".pt-hm a[href]"); if (!a) return;
    var href = a.getAttribute("href") || ""; if (!href || href.charAt(0) === "#" || a.target === "_blank") return;
    a.classList.add("pt-pressed"); setTimeout(function () { a.classList.remove("pt-pressed"); }, 4000);
  });
  window.addEventListener("pageshow", function (e) { if (e.persisted) [].forEach.call(document.querySelectorAll(".pt-hm .pt-pressed"), function (el) { el.classList.remove("pt-pressed"); }); });

  /* ---- scroll-in reveals ---- */
  var revealIO = null;
  function reveals() {
    var els = [].slice.call(document.querySelectorAll(".pt-hm-reveal:not(.pt-in)"));
    if (!els.length) return;
    if (reduced || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("pt-in"); }); return; }
    /* anything already in view shows at once (staggered); the observer handles
       the rest. Safety: nothing above the fold may stay hidden if the observer
       never reports (background tab on load) — re-check on visibility/scroll. */
    var vh = window.innerHeight || 800, k = 0;
    els = els.filter(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh * 0.95 && r.bottom > 0) { (function (e, d) { setTimeout(function () { e.classList.add("pt-in"); }, d); })(el, k * 60); k++; return false; } return true; });
    if (!els.length) return;
    if (!revealIO) revealIO = new IntersectionObserver(function (entries) {
      var i = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; revealIO.unobserve(el);
        setTimeout(function () { el.classList.add("pt-in"); }, i * 60); i++;
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (el) { revealIO.observe(el); });
  }

  /* ---- stat count-up (one time, ≤600ms) ---- */
  function countUps() {
    var els = [].slice.call(document.querySelectorAll("[data-hm-count]:not([data-done])"));
    if (!els.length || reduced || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.setAttribute("data-done", "1"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el); el.setAttribute("data-done", "1");
        var text = el.textContent, m = /^([^\d]*)([\d.,]+)(.*)$/.exec(text); if (!m) return;
        var raw = m[2], dec = (raw.split(".")[1] || "").length, target = parseFloat(raw.replace(/,/g, "")), useComma = raw.indexOf(",") !== -1;
        if (isNaN(target)) return;
        var t0 = null, dur = 600;
        function fmt(v) { var s = v.toFixed(dec); if (useComma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ","); return m[1] + s + m[3]; }
        function step(ts) { if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur); p = 1 - Math.pow(1 - p, 3); el.textContent = fmt(target * p); if (p < 1) requestAnimationFrame(step); else el.textContent = text; }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- press quote cycler ---- */
  function press(root) {
    if (!root || root.__ptInit) return; root.__ptInit = true;
    var quote = root.querySelector("[data-hm-quote]"), logos = [].slice.call(root.querySelectorAll("[data-hm-logo]"));
    if (!quote || !logos.length) return;
    var items = logos.map(function (b) { return { btn: b, quote: b.getAttribute("data-quote") || "", attr: b.getAttribute("data-attr") || "", via: b.getAttribute("data-via") || "" }; });
    var cur = Math.max(0, logos.findIndex(function (b) { return b.getAttribute("aria-pressed") === "true"; }));
    var timer = null, pinned = false, visible = true, qin = quote.querySelector(".pt-hm-quote-in") || quote;
    /* LAYOUT RULE (owner): self-moving content never shifts what is below it.
       Measure every quote once and lock the row to the tallest, re-measured on
       resize, so cycling or clicking never moves the page. */
    function lockHeight() {
      var probe = qin.cloneNode(false); probe.className = qin.className + " pt-hm-probe"; probe.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;left:0;right:0";
      quote.appendChild(probe);
      var max = 0;
      items.forEach(function (it) { probe.innerHTML = "“" + esc(it.quote) + "” <b>" + esc(it.attr) + (it.via ? '<span class="pt-hm-attr-via"> · ' + esc(it.via) + "</span>" : "") + "</b>"; max = Math.max(max, probe.offsetHeight); });
      quote.removeChild(probe);
      if (max) quote.style.height = (max + 2) + "px";
    }
    function paint(i) {
      var it = items[i];
      qin.innerHTML = "“" + esc(it.quote) + "” <b>" + esc(it.attr) + (it.via ? '<span class="pt-hm-attr-via"> · ' + esc(it.via) + "</span>" : "") + "</b>";
      logos.forEach(function (b, j) { b.setAttribute("aria-pressed", j === i ? "true" : "false"); });
    }
    function show(i, instant) {
      if (i === cur && !instant) return;
      cur = i;
      if (instant || reduced) { paint(i); return; }
      qin.classList.add("pt-hm-fade");
      setTimeout(function () { paint(i); qin.classList.remove("pt-hm-fade"); }, 300);
    }
    function start() { if (reduced || pinned || timer) return; timer = setInterval(function () { if (visible && !document.hidden) show((cur + 1) % items.length); }, 4000); }
    function stop() { clearInterval(timer); timer = null; }
    logos.forEach(function (b, i) { b.addEventListener("click", function () { pinned = true; stop(); show(i); }); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    paint(cur); lockHeight(); start();
    var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(lockHeight, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(lockHeight);
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }

  /* ---- header: transparent over the splash, paper after ---- */
  var glassBound = false;
  function glass() {
    var splash = document.querySelector("[data-hm-splash]"), hdr = document.getElementById("site-header");
    var html = document.documentElement;
    if (!splash || !hdr || !hdr.classList.contains("pt-hdr")) { html.classList.remove("pt-glass-page"); if (hdr) hdr.classList.remove("pt-hdr--glass"); return; }
    html.classList.add("pt-glass-page");
    var wrap = hdr.closest(".shopify-section") || hdr;
    function measure() { var h = wrap.offsetHeight || 53; html.style.setProperty("--pt-hdr-h", h + "px"); return h; }
    function tick() {
      var h = measure(), r = splash.getBoundingClientRect();
      var on = r.bottom > h + 24;   /* header still over the image */
      hdr.classList.toggle("pt-hdr--glass", on);
      wrap.classList.toggle("pt-hdr-section--glass", on);
    }
    tick();
    if (!glassBound) { glassBound = true; window.addEventListener("scroll", tick, { passive: true }); window.addEventListener("resize", tick); if (window.ResizeObserver) new ResizeObserver(tick).observe(wrap); }
  }

  /* splash photo fades in over its blurred stand-in once it has really loaded */
  function splashImgs() {
    [].forEach.call(document.querySelectorAll(".pt-hm-splash-media img.pt-hm-d, .pt-hm-splash-media img.pt-hm-m"), function (img) {
      if (img.__ptBound) return; img.__ptBound = true;
      var on = function () { img.classList.add("pt-loaded"); };
      if (img.complete && img.naturalWidth > 0) on(); else { img.addEventListener("load", on); img.addEventListener("error", on); }
    });
  }
  function init() {
    [].forEach.call(document.querySelectorAll("[data-hm-press]"), press);
    splashImgs(); reveals(); countUps(); glass();
  }
  document.addEventListener("visibilitychange", function () { if (!document.hidden) reveals(); });
  window.addEventListener("scroll", function () { if (document.querySelector(".pt-hm-reveal:not(.pt-in)")) reveals(); }, { passive: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function (e) { var p = e.target && e.target.querySelector && e.target.querySelector("[data-hm-press]"); if (p) p.__ptInit = false; init(); });
  document.addEventListener("shopify:section:unload", function () { setTimeout(init, 50); });
})();
